var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studentSieId)?_c('div',[_c('Portal',{attrs:{"to":"sub-header"}},[_c('StudentBanner',{ref:"SelectedStudent",attrs:{"student":_vm.student}})],1),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }